/**
 * Small wrapper around local storage to ignore security errors.
 * Only really useful when you don't care that it isn't working.
 * Called localData to make it clear you aren't using localStorage directly.
 */

export const getItem = (key) => {
    try {
        return localStorage.getItem(key)
    } catch (e) {
        return undefined
    }
}

export const setItem = (key, value) => {
    try {
        localStorage.setItem(key, value)
    } catch (e) {
        // Ignore
    }
}